import axios from "axios";
import {
  clearAxiosAuthorization,
  clearPersistedAuthentication,
} from '@/services/guestSession';

export default {
  async Login({ commit }, Form) {
    try {
      const response = await axios.post("/user_login", Form);
      const user = response.data.user;
      const token = user.api_token;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
      commit("setUser", { user, token });

      return response;
    } catch (error) {
      return error.response;
    }
  },

  logout({ commit }) {
    clearPersistedAuthentication();
    clearAxiosAuthorization(axios);
    commit("logout");
  },
};
